import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg viewBox="0 0 150 150" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#51565C"
        d="M98.29 64.448c0 1.433-.524 2.66-1.572 3.682-1.049 1.023-2.56 1.656-4.535 1.9v2.936h-2.62V70.11a14.26 14.26 0 0 1-3.696-.681c-1.171-.385-2.115-.856-2.831-1.415l1.441-3.198c.664.49 1.442.9 2.333 1.232.891.332 1.809.541 2.752.629v-4.377c-1.24-.297-2.289-.63-3.145-.996a5.546 5.546 0 0 1-2.15-1.612c-.576-.708-.864-1.647-.864-2.818 0-1.45.528-2.695 1.586-3.735 1.057-1.04 2.581-1.673 4.573-1.9v-2.91h2.621v2.857c2.15.175 3.923.708 5.321 1.6l-1.31 3.223c-1.311-.751-2.648-1.206-4.01-1.363v4.456c1.223.28 2.258.598 3.105.957.848.358 1.56.89 2.136 1.598.577.708.865 1.639.865 2.792zm-10.667-7.785c0 .437.166.795.498 1.075.332.28.812.515 1.441.708v-3.722c-.664.157-1.153.406-1.467.747-.315.34-.472.738-.472 1.192zm4.56 9.908c.63-.14 1.101-.367 1.416-.682.314-.314.472-.69.472-1.127 0-.436-.162-.795-.485-1.074-.324-.28-.791-.524-1.403-.734v3.617z"
      />
      <path stroke="#51565C" strokeWidth="3.5" d="M64.453 34h52.42v52.421h-52.42z" />
      <g>
        <path stroke="#51565C" strokeWidth="3.5" d="M33 63.88h52.421v52.421H33z" />
        <g stroke="#FFF" strokeWidth="1.2">
          <path
            fill="#53A2D9"
            d="M35.458 78.133h11.744v11.744H35.458V78.133zM47.253 65.901h11.744v11.745H47.253V65.9z"
          />
          <path
            fill="#7BB835"
            d="M71.716 65.901H83.46v11.745H71.716V65.9zM47.253 90.364h11.744v11.744H47.253zM35.458 102.16h11.744v11.743H35.458zM59.484 78.133H71.23v11.744H59.484V78.133z"
          />
          <path
            fill="#15539F"
            d="M71.279 90.364h11.744v11.745H71.28V90.364zM59.484 102.159H71.23v11.744H59.484V102.16z"
          />
        </g>
      </g>
    </g>
  </Svg>
)
